var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Guild.less');

module.exports = Section.extend({

    el: '.Guild',

    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Guild/Guild.js
// module id = 270
// module chunks = 0